import { css } from 'emotion';
import { lightGrey, darkGrey } from 'inside-out/global-styles';
import NextArrowIcon from './next-arrow.svg';
import NextArrowDisabledIcon from './next-arrow-disabled.svg';

export const currentPageStyle = css({});

export const ellipsisStyle = css({});

export const wrapperStyle = css({
	'& ul': {
		margin: '60px auto',
		padding: '0',
		display: 'table',
		borderCollapse: 'collapse',

		'& li': {
			display: 'inline-block',
			border: `1px solid ${lightGrey}`,
			borderLeft: 'none',
			background: '#fff',

			'&:nth-last-of-type(2)': {
				borderRadius: '0 6px 6px 0',
			},

			'& a': {
				display: 'block',
				width: '100%',
				height: '100%',
				padding: '10px 15px',
				fontSize: '16px',
				lineHeight: '22px',
				color: darkGrey,
				textDecoration: 'none',
				cursor: 'pointer',
			},
			[`&.${currentPageStyle}`]: {
				background: lightGrey,
			},
			[`&.${ellipsisStyle}`]: {
				border: 'none',
				background: 'transparent',
				'& + li': {
					borderLeft: `1px solid ${lightGrey}`,
				},
			},

			['&.disabled a']: {
				cursor: 'default',
			},
			['&.previous']: {
				border: 'none',
				background: `transparent url(${NextArrowIcon}) no-repeat center center`,
				textIndent: '-99999px',
				transform: 'rotate(180deg)',
				['&.disabled']: {
					backgroundImage: `url(${NextArrowDisabledIcon})`,
				},
				'& + li': {
					borderRadius: '6px 0 0 6px',
					borderLeft: `1px solid ${lightGrey}`,
				},
			},
			['&.next']: {
				border: 'none',
				background: `transparent url(${NextArrowIcon}) no-repeat center center`,
				textIndent: '-99999px',
				['&.disabled']: {
					backgroundImage: `url(${NextArrowDisabledIcon})`,
				},
			},
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/pagination/styles.js